var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 255.12 255.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Podere Colle San Massimo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 206.79,
    width: 96.64,
    height: 24.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 158.47,
    y: 24.16,
    width: 96.65,
    height: 72.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 158.47,
    y: 158.47,
    width: 24.16,
    height: 96.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.18,
    y: 24.16,
    width: 72.46,
    height: 24.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 206.8,
    y: 158.47,
    width: 24.16,
    height: 96.65
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "134.31 0 120.81 0 120.81 72.49 24.18 72.49 24.18 120.81 0 120.81 0 134.3 120.81 134.3 120.81 158.47 24.18 158.47 24.18 182.63 120.81 182.63 120.81 255.11 134.31 255.11 134.31 134.3 255.12 134.3 255.12 120.81 134.31 120.81 134.31 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoClear);
export default __webpack_public_path__ + "static/media/logo-clear.111d6e02164fa15c723b3c0f3c6ea240.svg";
export { ForwardRef as ReactComponent };